import ReactGA from 'react-ga4';

function sendSubmitButtonGAEvent(embedId) {
    ReactGA.event({
        category: "Video",
        action: "submit",
        label: `embedId=${embedId}`
    });
}

function sendMarkButtonGAEvent(embedId) {
    ReactGA.event({
        category: "Video",
        action: "markClick",
        label: `embedId=${embedId}`
    });
}

export {sendSubmitButtonGAEvent, sendMarkButtonGAEvent};